var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"OurRadioGroup",class:_vm.themeClass,attrs:{"data-cy":_vm.dataCy}},[(_vm.label)?_c('h3',{staticClass:"label-title"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"radio-group-wrapper",class:_vm.labelClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }